import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { WaremaIconButton } from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-breadcrumb-back',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    imports: [TranslatePipe, RouterLink, WaremaIconButton],
})
export class BreadcrumbComponent {
    public readonly translationKey = input.required<string>();
    public readonly routerLink = input.required<string>();
}
